export type GroupExpandedMap = { [groupId: string]: boolean };

export interface AppChromeState {
    readonly beingAddedFolderNames: string[];
    readonly expandedGroups: GroupExpandedMap;
}

export const packageStateKey = 'appchrome';
